import { GuidedTourStatus } from '../models/guided-tour-state.model';

export class GetGuidedTourToggleStatus {
    static readonly type = '[GuidedTour] Get Toggle Status';
}

export class SetGuidedTourToggleStatus {
    static readonly type = '[GuidedTour] Set Toggle Status';
    constructor(public status: GuidedTourStatus) {}
}
